import { styled, Box, Typography } from "@mui/material";
import { dumontColors } from "../../../colors";

export const MessageContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  gap: "12px",
  width: "100%",
});

export const IconContainer = styled(Box)({
  width: "32px",
  height: "32px",
  borderRadius: "6px",
  backgroundColor: "rgba(0, 164, 159, 0.05)",
  border: "1px solid rgba(0, 164, 159, 0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
});

export const ContentContainer = styled(Box)({
  width: "311px",
  height: "410px",
  backgroundColor: dumontColors.gray100,
  borderRadius: "8px",
  padding: "8px 12px 0px",
});

export const InnerContent = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

export const HeaderText = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "1.4em",
  color: dumontColors.text,
  width: "282px",
});

export const OrderContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "4px",
});

export const OrderText = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "1.4em",
  color: dumontColors.text,
  width: "282px",
});

export const OrderDetailsContainer = styled(Box)({
  paddingLeft: "20px",
});

export const ViewDetailsLink = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "1.4em",
  color: dumontColors.primary,
  cursor: "pointer",
  width: "fit-content",
  "&:hover": {
    textDecoration: "underline",
  },
});

export const FooterText = styled(Typography)({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 400,
  lineHeight: "1.4em",
  color: dumontColors.text,
  width: "282px",
});
